import React, { type FC } from 'react';

import { fg } from '@confluence/feature-gating';
import {
	createSingleQueryParamHook,
	useRouteActions,
} from '@confluence/route-manager/entry-points/RouteState';

const useFocusedTaskIdQueryParam = createSingleQueryParamHook('focusedTaskId');

const TaskScrollComponentInner: FC = () => {
	const focusedTaskId = useFocusedTaskIdQueryParam();
	const { setQueryParams } = useRouteActions();

	if (focusedTaskId) {
		const taskElement = document.querySelector(`[data-task-local-id="${focusedTaskId}"]`);
		if (taskElement) {
			taskElement.scrollIntoView({
				behavior: 'instant',
				inline: 'center',
				block: 'center',
			});
			// Remove the query param immediately after task scroll is complete
			setQueryParams({
				focusedTaskId: undefined,
			});
		}
	}

	return null;
};

export const TaskScrollComponent: FC = () => {
	if (!fg('confluence_frontend_focused-task-scroll')) {
		return null;
	}

	return <TaskScrollComponentInner />;
};
